// extracted by mini-css-extract-plugin
export default {"awards":"awards__MjIzY","awardsList":"awardsList__N2I2N","award":"award__MThkN","toolTip":"toolTip__ZjhhY"};